export class NumberFormatter {
    static getShortValueToDisplay(value: number): string {
        if (value > 1000000000) {
            return NumberFormatter.getValueToDisplayWithSuffix(value, 1000000000, "G");
        } else if (value > 1000000) {
            return NumberFormatter.getValueToDisplayWithSuffix(value, 1000000, "M");
        } else if (value > 1000) {
            return NumberFormatter.getValueToDisplayWithSuffix(value, 1000, "k");
        } else {
            return value.toFixed();
        }
    }

    static getValueToDisplayWithSuffix(value: number, factor: number, suffix: string) {
        let dividedValue = value / factor;
        let numFractionDigits = dividedValue >= 100 ? 0 : 1;
        return `${dividedValue.toFixed(numFractionDigits)}${suffix}`;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/core/numberFormatter.ts